import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, ChevronDownIcon } from 'lucide-react';
const SERVICE_LINKS = [{
  name: 'Backyard Cleaning',
  href: '/services/backyard-cleaning'
}, {
  name: 'Commercial Cleaning',
  href: '/services/commercial-cleaning'
}, {
  name: 'Driveway Cleaning',
  href: '/services/driveway-cleaning'
}, {
  name: 'Paver Cleaning',
  href: '/services/paver-cleaning'
}, {
  name: 'Solar Panel Cleaning',
  href: '/services/solar-panel-cleaning'
}, {
  name: 'Trash Can Cleaning',
  href: '/services/trash-can-cleaning'
}, {
  name: 'Window Cleaning',
  href: '/services/window-cleaning'
}];
const LOCATION_LINKS = [{
  name: 'Ahwatukee Foothills',
  href: '/locations/ahwatukee-foothills'
}, {
  name: 'Casa Grande',
  href: '/locations/casa-grande'
}, {
  name: 'Chandler',
  href: '/locations/chandler'
}, {
  name: 'Gilbert',
  href: '/locations/gilbert'
}, {
  name: 'Litchfield Park',
  href: '/locations/litchfield-park'
}, {
  name: 'Maricopa',
  href: '/locations/maricopa'
}, {
  name: 'Mesa',
  href: '/locations/mesa'
}, {
  name: 'Phoenix',
  href: '/locations/phoenix'
}, {
  name: 'Queen Creek',
  href: '/locations/queen-creek'
}, {
  name: 'Scottsdale',
  href: '/locations/scottsdale'
}, {
  name: 'Sun Lakes',
  href: '/locations/sun-lakes'
}, {
  name: 'Tempe',
  href: '/locations/tempe'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileLocationsOpen, setMobileLocationsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300" style={{
    backgroundColor: '#0283C7',
    boxShadow: scrolled ? '0 4px 24px rgba(2,131,199,0.35)' : 'none'
  }} data-id="element-519">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-520">
        <div className="flex items-center justify-between h-16 md:h-20" data-id="element-521">
          {/* Logo */}
          <a href="/" className="flex items-center flex-shrink-0" data-id="element-522">
            <img src="https://cdn.magicpatterns.com/uploads/3rDr76G2xKESSQAdSYdtBE/BlueCactus_Power_Washing_Logo_White.svg" alt="Blue Cactus Power Washing" className="h-14" data-id="element-523" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" aria-label="Main navigation" data-id="element-524">
            {/* Services Dropdown */}
            <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-525">
              <button className="font-medium text-sm text-white transition-opacity hover:opacity-75 flex items-center gap-1" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-526">
                Services
                <ChevronDownIcon className="h-3.5 w-3.5" data-id="element-527" />
              </button>
              {servicesOpen && <div className="absolute top-full left-0 pt-2 w-56" data-id="element-528">
                  <div className="rounded-lg py-2 shadow-xl" style={{
                backgroundColor: '#ffffff'
              }} data-id="element-529">
                    {SERVICE_LINKS.map(s => <a key={s.name} href={s.href} className="block px-4 py-2.5 text-sm font-medium transition-colors hover:bg-blue-50" style={{
                  color: '#025A8A',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-530">
                        {s.name}
                      </a>)}
                  </div>
                </div>}
            </div>

            <a href="/about" className="font-medium text-sm text-white transition-opacity hover:opacity-75" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-531">
              About Us
            </a>

            {/* Locations Dropdown */}
            <div className="relative" onMouseEnter={() => setLocationsOpen(true)} onMouseLeave={() => setLocationsOpen(false)} data-id="element-532">
              <button className="font-medium text-sm text-white transition-opacity hover:opacity-75 flex items-center gap-1" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-533">
                Locations
                <ChevronDownIcon className="h-3.5 w-3.5" data-id="element-534" />
              </button>
              {locationsOpen && <div className="absolute top-full left-0 pt-2 w-56" data-id="element-535">
                  <div className="rounded-lg py-2 shadow-xl" style={{
                backgroundColor: '#ffffff'
              }} data-id="element-536">
                    {LOCATION_LINKS.map(l => <a key={l.name} href={l.href} className="block px-4 py-2.5 text-sm font-medium transition-colors hover:bg-blue-50" style={{
                  color: '#025A8A',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-537">
                        {l.name}
                      </a>)}
                  </div>
                </div>}
            </div>

            <a href="/contact" className="font-medium text-sm text-white transition-opacity hover:opacity-75" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-538">
              Contact Us
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4" data-id="element-539">
            <a href="tel:4805998442" className="flex items-center gap-2 font-semibold text-sm text-white transition-opacity hover:opacity-80" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-540">
              <PhoneIcon className="h-4 w-4" data-id="element-541" />
              (480) 599-8442
            </a>
            <a href="#contact" className="font-bold text-sm px-5 py-2.5 rounded-lg transition-all duration-200 hover:scale-105" style={{
            backgroundColor: '#ffffff',
            color: '#0283C7',
            fontFamily: 'Inter, sans-serif',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
          }} data-id="element-542">
              Get a Free Quote
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button className="lg:hidden p-2 rounded-md" onClick={() => setIsOpen(!isOpen)} aria-label={isOpen ? 'Close menu' : 'Open menu'} aria-expanded={isOpen} data-id="element-543">
            {isOpen ? <XIcon className="h-6 w-6 text-white" data-id="element-544" /> : <MenuIcon className="h-6 w-6 text-white" data-id="element-545" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="lg:hidden border-t" style={{
      backgroundColor: '#025A8A',
      borderColor: 'rgba(255,255,255,0.15)'
    }} data-id="element-546">
          <nav className="px-4 py-4 flex flex-col gap-1" aria-label="Mobile navigation" data-id="element-547">
            {/* Services Accordion */}
            <button className="font-medium text-base text-white py-3 px-2 border-b transition-opacity hover:opacity-75 flex items-center justify-between w-full text-left" style={{
          borderColor: 'rgba(255,255,255,0.12)',
          fontFamily: 'Inter, sans-serif'
        }} onClick={() => setMobileServicesOpen(!mobileServicesOpen)} data-id="element-548">
              Services
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileServicesOpen ? 'rotate-180' : ''}`} data-id="element-549" />
            </button>
            {mobileServicesOpen && <div className="pl-4 flex flex-col gap-1" data-id="element-550">
                {SERVICE_LINKS.map(s => <a key={s.name} href={s.href} className="text-sm text-white py-2 px-2 transition-opacity hover:opacity-75" style={{
            fontFamily: 'Inter, sans-serif',
            opacity: 0.85
          }} onClick={() => setIsOpen(false)} data-id="element-551">
                    {s.name}
                  </a>)}
              </div>}

            <a href="/about" className="font-medium text-base text-white py-3 px-2 border-b transition-opacity hover:opacity-75" style={{
          borderColor: 'rgba(255,255,255,0.12)',
          fontFamily: 'Inter, sans-serif'
        }} onClick={() => setIsOpen(false)} data-id="element-552">
              About Us
            </a>

            {/* Locations Accordion */}
            <button className="font-medium text-base text-white py-3 px-2 border-b transition-opacity hover:opacity-75 flex items-center justify-between w-full text-left" style={{
          borderColor: 'rgba(255,255,255,0.12)',
          fontFamily: 'Inter, sans-serif'
        }} onClick={() => setMobileLocationsOpen(!mobileLocationsOpen)} data-id="element-553">
              Locations
              <ChevronDownIcon className={`h-4 w-4 transition-transform ${mobileLocationsOpen ? 'rotate-180' : ''}`} data-id="element-554" />
            </button>
            {mobileLocationsOpen && <div className="pl-4 flex flex-col gap-1" data-id="element-555">
                {LOCATION_LINKS.map(l => <a key={l.name} href={l.href} className="text-sm text-white py-2 px-2 transition-opacity hover:opacity-75" style={{
            fontFamily: 'Inter, sans-serif',
            opacity: 0.85
          }} onClick={() => setIsOpen(false)} data-id="element-556">
                    {l.name}
                  </a>)}
              </div>}

            <a href="/contact" className="font-medium text-base text-white py-3 px-2 border-b transition-opacity hover:opacity-75" style={{
          borderColor: 'rgba(255,255,255,0.12)',
          fontFamily: 'Inter, sans-serif'
        }} onClick={() => setIsOpen(false)} data-id="element-557">
              Contact Us
            </a>

            <div className="pt-4 flex flex-col gap-3" data-id="element-558">
              <a href="tel:4805998442" className="flex items-center justify-center gap-2 font-semibold text-base text-white py-3 rounded-lg border" style={{
            borderColor: 'rgba(255,255,255,0.4)',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-559">
                <PhoneIcon className="h-4 w-4" data-id="element-560" />
                (480) 599-8442
              </a>
              <a href="#contact" className="font-bold text-base text-center py-3 rounded-lg" style={{
            backgroundColor: '#ffffff',
            color: '#0283C7',
            fontFamily: 'Inter, sans-serif',
            borderRadius: '8px'
          }} onClick={() => setIsOpen(false)} data-id="element-561">
                Get a Free Quote
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}